import { isNil } from "~/lib/lodash";
import { type MarketDataDatasetEmployee } from "~/services/market-data/dataset-employee/getMarketDataDatasetEmployees";
import { type MarketDataEmployee } from "~/services/market-data/getMarketDataEmployees";

type EmployeeForFilter = Partial<MarketDataEmployee>;

export type BenchmarkLevelForFilter = {
  min: number | null;
  max: number | null;
};

export const filterEmployeesInRange = (
  employee: EmployeeForFilter,
  benchmarkLevelRange: BenchmarkLevelForFilter
): boolean => {
  const { benchmarkLevel } = employee;
  const { min, max } = benchmarkLevelRange;

  if (isNil(benchmarkLevel)) {
    return false;
  }

  const employeeMin = benchmarkLevel.min;
  const employeeMax = benchmarkLevel.max;

  const isWithinRange =
    (min === null || employeeMax >= min) && // Employee's max must be >= range min
    (max === null || employeeMin <= max); // Employee's min must be <= range max

  return isWithinRange;
};

export const filterDatasetEmployeesInRange = (
  datasetEmployee: MarketDataDatasetEmployee,
  benchmarkLevelRange: BenchmarkLevelForFilter
): boolean => {
  const { benchmarkLevelMin, benchmarkLevelMax } = datasetEmployee;
  const { min, max } = benchmarkLevelRange;

  if (isNil(benchmarkLevelMin) || isNil(benchmarkLevelMax)) {
    return false;
  }

  const isWithinRange =
    (min === null || benchmarkLevelMax >= min) && // Employee's max must be >= range min
    (max === null || benchmarkLevelMin <= max); // Employee's min must be <= range max

  return isWithinRange;
};
